import AttendeeList from "./components/List"
import AttendeeForm from "./components/Form"
import AttendeeView from "./components/View"
import Accomplishment from "./components/Accomplishment"

let module = "attendees"

export default [
  { path: "attendees", component: AttendeeList, meta: { module: module, permissions: ["attendee-access"] } },
  {
    path: "attendees/create",
    component: AttendeeForm,
    props: true,
    meta: { module: module, permissions: ["attendee-create"] }
  },
  {
    path: "attendees/edit/:id",
    component: AttendeeForm,
    props: true,
    meta: { module: module, permissions: ["attendee-edit"] }
  },
  {
    path: "attendees/view/:id",
    component: AttendeeView,
    props: true,
    meta: { module: module, permissions: ["attendee-access"] }
  },
  {
    path: "accomplishment/:id",
    component: Accomplishment,
    props: true,
    meta: { module: module, permissions: ["all"] }
  }
]
